module.exports = __webpack_public_path__ + "static/media/logo.151be66e.png";